import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "sceneConstructorStartMenu" }
const _hoisted_2 = {
  key: 1,
  fill: "currentColor",
  viewBox: "0 0 512 512"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "m459 75l-22-22l-384 384l22 22l55-54l291 0c10 0 16-7 16-16l0-271c0-5-3-10-7-14z m-214 282c-20 0-38-5-54-14l24-24c9 4 19 6 30 6c44 0 80-36 80-80c0-11-2-20-6-30l24-23c9 15 14 34 14 53c0 62-51 112-112 112z m-99-59c-9-16-13-34-13-53c0-62 50-112 112-112c19 0 37 5 53 13l45-45l-2 0l-48-48l-96 0l-48 48l-78 0c-9 0-18 8-18 17l0 271c0 0 0 1 0 2z m99-134c-45 0-81 36-81 81c0 10 2 20 6 29l104-104c-9-3-19-6-29-6z" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  fill: "currentColor",
  viewBox: "0 0 512 512"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", { d: "m459 75l-22-22l-384 384l22 22l55-54l291 0c10 0 16-7 16-16l0-271c0-5-3-10-7-14z m-214 282c-20 0-38-5-54-14l24-24c9 4 19 6 30 6c44 0 80-36 80-80c0-11-2-20-6-30l24-23c9 15 14 34 14 53c0 62-51 112-112 112z m-99-59c-9-16-13-34-13-53c0-62 50-112 112-112c19 0 37 5 53 13l45-45l-2 0l-48-48l-96 0l-48 48l-78 0c-9 0-18 8-18 17l0 271c0 0 0 1 0 2z m99-134c-45 0-81 36-81 81c0 10 2 20 6 29l104-104c-9-3-19-6-29-6z" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  fill: "currentColor",
  viewBox: "0 0 512 512"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("path", { d: "m459 75l-22-22l-384 384l22 22l55-54l291 0c10 0 16-7 16-16l0-271c0-5-3-10-7-14z m-214 282c-20 0-38-5-54-14l24-24c9 4 19 6 30 6c44 0 80-36 80-80c0-11-2-20-6-30l24-23c9 15 14 34 14 53c0 62-51 112-112 112z m-99-59c-9-16-13-34-13-53c0-62 50-112 112-112c19 0 37 5 53 13l45-45l-2 0l-48-48l-96 0l-48 48l-78 0c-9 0-18 8-18 17l0 271c0 0 0 1 0 2z m99-134c-45 0-81 36-81 81c0 10 2 20 6 29l104-104c-9-3-19-6-29-6z" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SceneConstructorMenuItemIcon = _resolveComponent("SceneConstructorMenuItemIcon")!
  const _component_SceneConstructorMenuItem = _resolveComponent("SceneConstructorMenuItem")!
  const _component_SceneConstructorMenu = _resolveComponent("SceneConstructorMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SceneConstructorMenu, null, {
      default: _withCtx(() => [
        _createVNode(_component_SceneConstructorMenuItem, {
          text: _ctx.$t('scene_constructor.background'),
          onClick: _cache[0] || (_cache[0] = () => _ctx.store.goTo('bgMenu'))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SceneConstructorMenuItemIcon, {
              backgroundColor: _ctx.state.backgroundColor,
              backgroundImage: _ctx.state.selectedBackground ? _ctx.state.selectedBackground.photo_box_url : ''
            }, {
              default: _withCtx(() => [
                (_ctx.state.selectedBackground)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "sceneConstructorStartMenu__bgColor",
                      style: _normalizeStyle({
              'background-color': _ctx.state.backgroundColor
            })
                    }, null, 4))
                  : _createCommentVNode("", true),
                (!_ctx.state.selectedBackground)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["backgroundColor", "backgroundImage"])
          ]),
          _: 1
        }, 8, ["text"]),
        _createVNode(_component_SceneConstructorMenuItem, {
          text: _ctx.$t('scene_constructor.logo'),
          onClick: _cache[1] || (_cache[1] = () => _ctx.store.goTo('logos'))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SceneConstructorMenuItemIcon, {
              backgroundImage: _ctx.state.selectedLogo ? _ctx.state.selectedLogo.url : ''
            }, {
              default: _withCtx(() => [
                (!_ctx.state.selectedLogo)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_7))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["backgroundImage"])
          ]),
          _: 1
        }, 8, ["text"]),
        _createVNode(_component_SceneConstructorMenuItem, {
          text: _ctx.$t('scene_constructor.banner'),
          onClick: _cache[2] || (_cache[2] = () => _ctx.store.goTo('banners'))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SceneConstructorMenuItemIcon, {
              backgroundImage: _ctx.state.selectedBanner ? _ctx.state.selectedBanner.url : ''
            }, {
              default: _withCtx(() => [
                (!_ctx.state.selectedBanner)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_10))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["backgroundImage"])
          ]),
          _: 1
        }, 8, ["text"])
      ]),
      _: 1
    })
  ]))
}